import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useHistory } from 'react-router-dom';
import { PATHS } from 'consts/paths';

const useGoogleTagManager = () => {
  const { location } = useHistory();

  useEffect(() => {
    if (
      [PATHS.REDIRECT_IMAGEYE, PATHS.REDIRECT_SIAT].includes(location.pathname) ||
      !process.env.REACT_APP_GOOGLE_TAG_ID
    ) {
      return;
    }

    TagManager.initialize({
      gtmId: process.env.REACT_APP_GOOGLE_TAG_ID,
      dataLayerName: 'gtm',
    });
  }, []);
};

export default useGoogleTagManager;
